export const SPECIALIZATIONS_SUCCESS = 'gustav/specializations/FETCH_SUCCESS';
export const SPECIALIZATIONS_ERROR = 'gustav/specializations/FETCH_ERROR';
